import React, { useEffect, useState } from "react";
import { Base64 } from "js-base64";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { message } from "antd";
import { Eye, EyeOff, Lock, CheckCircle, XCircle, Shield, ArrowLeft } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";


function ForgotPasswordReset(props) {
  const [msg, setMsg] = useState("");
  const [color, setColor] = useState("red");
  const [showLoader, setLoader] = useState(false);

  const navigate = useNavigate();


  const [password, setPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [confirmValidation, setConfirmValidation] = useState("");
  const [newPassValidation, setNewPassValidation] = useState("");
  const location = useLocation();
  const params = location.state.patientCode

  console.log("patient code in next page", params);

  const handlePasswordChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value.trim(),
    });
    passwordValidate(e.target.value);

    if (e.target.value.trim().length === 0) {
      setConfirmValidation("");
      return;
    }
  };

  const handlePasswordChangeNewPassword = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value.trim(),
    });
    passwordValidateNew(e.target.value);

    if (e.target.value.trim().length === 0) {
      setNewPassValidation("");
      return;
    }
  };

  // useEffect(() => {
  //   setPassword({
  //     newPassword: "",
  //     confirmPassword: "",
  //   });
  // }, [isError]);

  const passwordValidateNew = (value) => {

    console.log(value, "dscksbascjblasjlc");
    const regexNum = /\d/;
    const regexUppercase = /[A-Z]/;
    const regexCharLength = /^.{8,72}$/;
    const special = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (!regexNum.test(value)) {
      setNewPassValidation("MUST contain at least one number");
    } else if (!regexUppercase.test(value)) {
      setNewPassValidation("MUST contain at least one uppercase letter");
    } else if (!regexCharLength.test(value)) {
      setNewPassValidation("MUST contain at least 8 characters");
    } else if (!special.test(value)) {
      setNewPassValidation(
        "MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?)"
      );
    } else if (value.length === 0) {
      setNewPassValidation("");
    } else {
      setNewPassValidation("");
    }
  };

  const passwordValidate = (value) => {
    console.log(value, "dscksbascjblasjlc");
    const regexNum = /\d/;
    const regexUppercase = /[A-Z]/;
    const regexCharLength = /^.{8,72}$/;
    const special = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (!regexNum.test(value)) {
      setConfirmValidation("MUST contain at least one number");
    } else if (!regexUppercase.test(value)) {
      setConfirmValidation("MUST contain at least one uppercase letter");
    } else if (!regexCharLength.test(value)) {
      setConfirmValidation("MUST contain at least 8 characters");
    } else if (!special.test(value)) {
      setConfirmValidation(
        "MUST contain at least one special character (!”#$%&'()*+,-./:;<=>?)"
      );
    } else {
      setConfirmValidation("");
    }
  };
  const isButtonDisabled =
    !password.newPassword ||
    !password.confirmPassword ||
    password.newPassword !== password.confirmPassword ||
    newPassValidation.length > 0 ||
    confirmValidation.length > 0;

    const passwordsMatch =
  password.newPassword &&
  password.confirmPassword &&
  password.newPassword === password.confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassValidation.length !== 0) return;



    if (password?.newPassword.length === 0) {
      setNewPassValidation("Please enter new Password");
      return;
    }
    if (password?.confirmPassword.length === 0) {
      setConfirmValidation("Please enter confirm Password");
      return;
    }
    if (password?.newPassword !== password?.confirmPassword) {
      setConfirmValidation(<p className="text-center font-thin text-md w-full">"Confirm Password doses not match New Password"</p>);
      return;
    }

    setConfirmValidation("");
    //setNewPassValidation("")

    setLoader(true);

    const data = {
      currentPasswordVal: Base64.encode(password.newPassword),
      patientCode: params,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASEURL}PatientPasswordConfig/resetpassword/`,
        data
      );

      if (response.data.success || response.status === 200) {
        setColor("green");
        setLoader(false);
        setConfirmValidation("The password has been reset successfully!");
        setTimeout(() => {
          message.success("The password reset successful, Try login with your new password");
          navigate("/", { state: { isLoginModalOpen: true } });
        }, 1500);
      }
    } catch (error) {
      setColor("red");
      setLoader(false);
      const errorMessage = error?.response?.data?.details?.[0] || error?.response?.data?.message || "Failed to reset password. Please try again.";
      message.error(errorMessage);
      setConfirmValidation(errorMessage);
    }
  };



  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 (#eff6ff) via-white (#ffffff) to-[#EAF3FA] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="bg-white (#ffffff) rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#004276] to-[#004276] px-8 py-6 text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="inline-flex items-center justify-center w-16 h-16 bg-white/20 (#ffffff33) rounded-full mb-4"
            >
              <Shield className="text-white (#ffffff)" size={32} />
            </motion.div>
            <h2 className="text-2xl font-bold text-white (#ffffff) mb-2">
              Reset Your Password
            </h2>
            <p className="text-blue-100 (#dbeafe) text-sm">
              Create a strong password to secure your account
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-8 space-y-6">
            {/* New Password Field */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 (#374151) flex items-center gap-2">
                <Lock size={16} className="text-blue-500 (#3b82f6)" />
                New Password
              </label>
              <div className="relative">
                <input
                  type={newPasswordShown ? "text" : "password"}
                  value={password.newPassword}
                  placeholder="Enter your new password"
                  name="newPassword"
                  onChange={handlePasswordChangeNewPassword}
                  className="w-full px-4 py-3 pr-12 border border-gray-200 (#e5e7eb) rounded-lg focus:ring-2 focus:ring-blue-500 (#3b82f6) focus:border-transparent transition-all bg-gray-50 (#f9fafb) hover:bg-white (#ffffff)"
                />
                <button
                  type="button"
                  onClick={() => setNewPasswordShown(!newPasswordShown)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 (#6b7280) hover:text-gray-700 (#374151) transition-colors"
                >
                  {newPasswordShown ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
              <AnimatePresence>
                {newPassValidation && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className="flex items-center gap-2 text-red-500 (#ef4444) text-sm"
                  >
                    <XCircle size={16} />
                    <span>{newPassValidation}</span>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* Password Requirements */}
            <div className="bg-gray-50 (#f9fafb) rounded-lg p-4 space-y-2">
              <h4 className="text-sm font-medium text-gray-700 (#374151) mb-3">Password Requirements:</h4>
              <div className="grid grid-cols-2 gap-2 text-xs">
                <div className={`flex items-center gap-2 ${password.newPassword.length >= 8 ? 'text-green-600 (#16a34a)' : 'text-gray-500 (#6b7280)'}`}>
                  {password.newPassword.length >= 8 ? <CheckCircle size={14} /> : <XCircle size={14} />}
                  <span>8+ characters</span>
                </div>
                <div className={`flex items-center gap-2 ${/\d/.test(password.newPassword) ? 'text-green-600 (#16a34a)' : 'text-gray-500 (#6b7280)'}`}>
                  {/\d/.test(password.newPassword) ? <CheckCircle size={14} /> : <XCircle size={14} />}
                  <span>One number</span>
                </div>
                <div className={`flex items-center gap-2 ${/[A-Z]/.test(password.newPassword) ? 'text-green-600 (#16a34a)' : 'text-gray-500 (#6b7280)'}`}>
                  {/[A-Z]/.test(password.newPassword) ? <CheckCircle size={14} /> : <XCircle size={14} />}
                  <span>One uppercase</span>
                </div>
                <div className={`flex items-center gap-2 ${/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password.newPassword) ? 'text-green-600 (#16a34a)' : 'text-gray-500 (#6b7280)'}`}>
                  {/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password.newPassword) ? <CheckCircle size={14} /> : <XCircle size={14} />}
                  <span>Special char</span>
                </div>
              </div>
            </div>

            {/* Confirm Password Field */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 (#374151) flex items-center gap-2">
                <Lock size={16} className="text-blue-500 (#3b82f6)" />
                Confirm Password
              </label>
              <div className="relative">
                <input
                  type={confirmPasswordShown ? "text" : "password"}
                  value={password.confirmPassword}
                  placeholder="Confirm your new password"
                  name="confirmPassword"
                  onChange={handlePasswordChange}
                  className="w-full px-4 py-3 pr-12 border border-gray-200 (#e5e7e rounded-lg focus:ring-2 focus:ring-blue-500 (#3b82f6) focus:border-transparent transition-all bg-gray-50 (#f9fafb) hover:bg-white (#ffffff)"
                />
                <button
                  type="button"
                  onClick={() => setConfirmPasswordShown(!confirmPasswordShown)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 (#6b7280) hover:text-gray-700 (#374151) transition-colors"
                >
                  {confirmPasswordShown ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
              <AnimatePresence>
                {confirmValidation && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className="flex items-center gap-2 text-red-500 (#ef4444) text-sm"
                  >
                    <XCircle size={16} />
                    <span>{confirmValidation}</span>
                  </motion.div>
                )}
                {!passwordsMatch && password.confirmPassword && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    className="flex items-center gap-2 text-red-500 (#ef4444) text-sm"
                  >
                    <XCircle size={16} />
                    <span>Passwords do not match</span>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* Submit Button */}
            <motion.button
              type="submit"
              disabled={isButtonDisabled || showLoader}
              whileHover={!isButtonDisabled ? { scale: 1.02 } : {}}
              whileTap={!isButtonDisabled ? { scale: 0.98 } : {}}
              className={`w-full py-3 px-4 rounded-lg font-medium text-white (#ffffff) transition-all duration-200 flex items-center justify-center gap-2 ${
                isButtonDisabled || showLoader
                  ? "bg-gray-300 (#d1d5db) cursor-not-allowed"
                  : "bg-gradient-to-r from-[#004276] to-[#004276] hover:from-[#003360] hover:to-[#003360] shadow-lg hover:shadow-xl"
              }`}
            >
              {showLoader ? (
                <>
                  <div className="w-5 h-5 border-2 border-white (#ffffff) border-t-transparent rounded-full animate-spin"></div>
                  <span>Resetting Password...</span>
                </>
              ) : (
                <>
                  <Shield size={20} />
                  <span>Reset Password</span>
                </>
              )}
            </motion.button>

            {/* Back to Login */}
            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate("/", { state: { isLoginModalOpen: true } })}
                className="text-blue-600 (#2563eb) hover:text-blue-800 (#1e40af) text-sm font-medium flex items-center gap-2 mx-auto transition-colors"
              >
                <ArrowLeft size={16} />
                <span>Back to Login</span>
              </button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
}

export default ForgotPasswordReset;
